export default {
  // 基础数据-服务类型
  serviceTypeCreate: "/cms/service/type/create", // 服务类型新增
  serviceTypeTree: "/cms/service/type/tree", // 服务类型树状列表
  serviceTypeEdit: "/cms/service/type/edit", // 服务类型编辑
  serviceTypeDelete: "/cms/service/type/delete", // 服务类型删除

  //基础数据-提供方式
  serviceModeCreate: "/cms/service/mode/create", // 服务类型新增
  serviceModeTree: "/cms/service/mode/tree", // 服务类型树状列表
  serviceModeEdit: "/cms/service/mode/edit", // 服务类型编辑
  serviceModeDelete: "/cms/service/mode/delete", // 服务类型删除
};
